export { default as createShouldForwardProp } from './createShouldForwardProp';

export const requestAnimationTick = () => {
  let isTicking = false;
  return (fn: Function) => {
    if (!isTicking) {
      window.requestAnimationFrame(() => {
        isTicking = false;
        fn();
      });
      isTicking = true;
    }
  };
};
